import { TextField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { isNoTouchDevice } from 'services/touch_device_detection';
const styledTextFieldCss = "s1egapn5";
const StyledTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledTextFieldCss, props.className)} />);
export const AdditionalInfo = ({
  fieldNamePrefix
}) => {
  const additionalInfoFieldName = `${fieldNamePrefix}.additionalInfo`;
  const [{
    value: additionalInfo
  }] = useFormField({
    name: additionalInfoFieldName
  });
  const [inputVisible, showInput, hideInput] = useBooleanState(!!additionalInfo);
  const toggleInput = inputVisible ? hideInput : showInput;
  if (inputVisible) {
    return <StyledTextField name={additionalInfoFieldName} aria-label={I18n.t('publisher.event_type_editor.sections.event_details.location.include_additional_information')} placeholder={`${I18n.t('publisher.event_type_editor.sections.event_details.location.include_additional_information')}...`} type="textarea" maxLength={255} size="small" autoFocus={isNoTouchDevice()} />;
  }
  return <MinimalButton spacingTop={8} fontSize="medium" onClick={toggleInput}>
      <AddMiniIcon />
      {I18n.t('publisher.event_type_editor.sections.event_details.location.include_additional_information')}
    </MinimalButton>;
};

require("./additional_info.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./additional_info.js");